import { __assign, __extends } from "tslib";
import * as React from 'react';
import { HeightAnimation } from '../../animations/height/height';
import { namespacedClassnames } from '../../common';
import { Text } from '../../new-libby/core/typography';
import { Icon } from '../icon/icon';
import { smallCollapsibleToggle } from '../../icons';
var Collapsible = /** @class */ (function (_super) {
    __extends(Collapsible, _super);
    function Collapsible() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleCollapsible = function () { return _this.props.onToggle(!_this.props.isOpen); };
        _this.getIsOpen = function () { return _this.props.disabled ? false : _this.props.isOpen; };
        return _this;
    }
    Collapsible.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('collapsible', props.className, { open: this.getIsOpen(), disabled: props.disabled });
        var textContent = typeof props.title === 'string' ? { html: props.title } : { children: props.title };
        return (React.createElement("div", { className: classNames },
            React.createElement("div", { className: 'title-wrapper', onClick: this.toggleCollapsible },
                React.createElement(Icon, { className: 'toggle-icon', icon: smallCollapsibleToggle }),
                React.createElement(Text, __assign({ type: 'tm', color: 't20', className: 'title' }, textContent))),
            React.createElement("div", { className: 'content-wrapper' },
                React.createElement(HeightAnimation, { show: this.getIsOpen() },
                    React.createElement("div", { className: 'content' }, props.children)))));
    };
    return Collapsible;
}(React.PureComponent));
export { Collapsible };
//# sourceMappingURL=collapsible.js.map